import WidgetWordOfTheDayContainer from 'components/WidgetWordOfTheDay/WidgetWordOfTheDayContainer'
import WidgetWordOfTheDayPresentation from 'components/WidgetWordOfTheDay/WidgetWordOfTheDayPresentation'
import WidgetWordOfTheDayData from 'components/WidgetWordOfTheDay/WidgetWordOfTheDayData'

export default {
  Container: WidgetWordOfTheDayContainer,
  Presentation: WidgetWordOfTheDayPresentation,
  Data: WidgetWordOfTheDayData,
}
